import type { SchemaAttributes } from '@@/api/types.js'

export type MergedSettingsData = SchemaAttributes<'MergedSettings'>

export const SearchDepartmentFilter = {
  ALL_DEPARTMENTS: 'ALL_DEPARTMENTS',
  THIS_DEPARTMENT: 'THIS_DEPARTMENT',
} as const satisfies Record<
  string,
  MergedSettingsData['super_search_department_filter']
>
